<template>
  <div>
    <div v-for="(value, index) in voteList" :key="index">
      <mdl-textfield
        :field-id="`candidate-${index}`"
        :label="`Candidate ${index + 1}`"
        placeholder="eg. Lisa Simpson"
        :bvalue="value"
        :is-disabled="isFieldDisabled(index, value)"
        :is-error="isFieldDuplicate(index)"
        @enter-pressed="focusNextInput(index)"
        @inputting="updateVoteSelection($event, index)"
      />
    </div>

    <div class="App-error-text-color" v-show="hasDuplicates">
      Error: You cannot vote for the same candidate more than once.
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import mdlTextfield from '@/components/mdlTextfield.vue';
import ToggleListItem from '../ToggleListItem.vue';

import {mapActions} from 'vuex';
import {sanitizeCandidate} from '@/vuex/helpers.js';

export default {
  props: {
    questionId: {
      type: [String, Number],
      required: true
    },
    votes: {
      type: Array
    },
    numPositions: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    mdlTextfield,
    ToggleListItem
  },
  computed: {
    hasDuplicates() {
      const uniqueOptions = _.uniq(
        this.votes.filter(Boolean).map(candidate => {
          return sanitizeCandidate(candidate);
        })
      );
      return uniqueOptions.length !== this.votes.filter(Boolean).length;
    }
  },
  methods: {
    ...mapActions('questions', ['updateVote']),
    isFieldDuplicate(index) {
      return (
        this.duplicateValues(this.voteList).indexOf(
          sanitizeCandidate(this.voteList[index])
        ) >= 0
      );
    },
    duplicateValues(array) {
      // Gets the names that appear more than once
      const groupedNames = _.groupBy(array.filter(Boolean), candidate =>
        sanitizeCandidate(candidate)
      );
      return Object.keys(groupedNames).filter(k => groupedNames[k].length > 1);
    },

    isFieldDisabled(index, value) {
      if (index === 0) {
        return false;
      } else if (!_.isEmpty(value)) {
        return false;
      } else if (index > this.votes.filter(Boolean).length) {
        return true;
      }
    },
    updateVoteSelection(value, index) {
      // Handle spaces so that they can be filtered out in the next step
      this.voteList[index] = value.trim() === '' ? value.trim() : value;

      let vote = null;

      // Sanitize all candidate names
      if (this.voteList.length > 0) {
        vote = this.voteList.map(v =>
          _.startCase(_.toLower(sanitizeCandidate(v)))
        );
      }

      // Filter all blank values before updating store
      vote = vote.filter(Boolean);

      // CHECK if vote is empty - an empty vote.selection property value will not work
      // If empty, insert default element [''] in array
      this.updateVote({
        questionId: this.questionId,
        vote: _.isEmpty(vote) ? [''] : vote
      });
    },
    // On Keyup Enter, go to the next field
    focusNextInput(index) {
      if (index === this.votes.length) {
        this.$events.$emit('go-input', 'questionButton');
      }
      // Go to the next input
      this.$events.$emit('go-input', `candidate-${index + 1}`);
    },
    initVoteList() {
      let voteList = this.votes;
      let fieldsToAdd = this.numPositions - this.votes.length;

      for (let i = 0; i < fieldsToAdd; i++) {
        voteList.push('');
      }
      this.voteList = voteList;
    }
  },
  data() {
    return {
      voteList: []
    };
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
    this.initVoteList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Questions/Elections/ElectionsVoteListNoCandidates.vue